export default function Background() {
  return (
    <section
      id="background"
      data-testid="background-section"
      className="relative px-6 md:px-12 py-20 md:py-28 border-b border-rule bg-paper"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-16">
          <div className="col-span-12 md:col-span-3">
            <div className="overline text-slate reveal">Practice background</div>
            <div className="mono text-xs text-slate mt-3 reveal">— 04</div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="background-heading"
              className="serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-ink reveal"
            >
              Operational seniority,
              <br />
              not consulting theatre.
            </h2>
          </div>
        </div>

        {/* Credentials with portrait */}
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-4">
            <div className="reveal overflow-hidden">
              <img
                src="/images/portrait.jpg"
                alt="Saran Gandhi"
                data-testid="background-portrait"
                className="w-full aspect-[3/4] object-cover img-editorial"
              />
            </div>
            <div className="mt-4 overline text-slate">Saran Gandhi · Founder · London</div>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-4 space-y-8">
            <div className="reveal">
              <div className="overline text-ink mb-2">Amazon · European Operations</div>
              <p className="text-base md:text-lg leading-relaxed text-ink/80">
                Most of a decade at Amazon, finishing as Senior Manager
                responsible for European operations across 10 countries and
                more than 100,000 frontline operators.
              </p>
            </div>

            <div className="rule reveal" />

            <div className="reveal">
              <div className="overline text-ink mb-2">Indian Army · Corps of EME</div>
              <p className="text-base md:text-lg leading-relaxed text-ink/80">
                21 years in engineering, logistics, and large-scale
                operational change in some of the most demanding operating
                environments anywhere.
              </p>
            </div>

            <div className="rule reveal" />

            <p className="reveal text-base md:text-lg leading-relaxed text-ink">
              Both careers share what most consulting backgrounds do not:
              personal accountability for whether things actually work — at
              scale, under load, with no second take.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
